import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import Post from '../../../components/Post/Post';
import { UserContext } from '../../../context/userContext';
import styles from './newfeed.module.css'

const Newfeed =()=>{

    const {user}=useContext(UserContext);

    const [post,setPost]=useState();
console.log(post)

    const fetchpost=()=>{
        axios.post("https://vsam.me/api/api.php?request=getUserPosts",{
           "user_id":user.userid,"token":user.token}
       ).then(res=>{
          setPost(Array.from(res.data.data))

       })
    }

 useEffect(()=>{
     fetchpost();
 },[])   


    return(
        <div className={styles.container}>
            {post?<>
            
            {post.map(p=>
            <div className={styles.postCon} key={p.Post_Id}>
                <Post
                Post_Url={p.Post_Url}
                Caption={p.Caption}
                Type={p.Type}
                />
            <br/>
            </div>)}
               
           
        </>:"loading"}
            

           
        </div>
    )
}

export default Newfeed;